import axiosInstance from "../../interceptor/axiosInstance";
import ApiRoutes from "../../routes/routeConstants/apiRoutes";
import { UserRoleEnum } from "../../enums/userRole.enum";
import { InAppNotification } from "../../types/inAppNotification";

function basePath(userRole: UserRoleEnum | undefined): string {
  if (userRole === UserRoleEnum.ADMIN) return ApiRoutes.ADMIN_APP_NOTIFICATIONS;
  if (userRole === UserRoleEnum.DOCTOR) return ApiRoutes.DOCTOR_APP_NOTIFICATIONS;
  if (userRole === UserRoleEnum.SCAN_CENTER)
    return ApiRoutes.SCAN_CENTER_APP_NOTIFICATIONS;
  return "";
}

export default class AppNotificationsService {
  static fetchList(
    userRole: UserRoleEnum | undefined,
    onSuccess: (data: {
      notifications: InAppNotification[];
      unread_count: number;
    }) => void,
    onError?: () => void
  ) {
    const path = basePath(userRole);
    if (!path) {
      onError?.();
      return;
    }
    axiosInstance
      .get(path)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch(() => onError?.());
  }

  static markRead(
    userRole: UserRoleEnum | undefined,
    id: number,
    onSuccess: (n: InAppNotification) => void,
    onError?: () => void
  ) {
    const path = basePath(userRole);
    if (!path) {
      onError?.();
      return;
    }
    axiosInstance
      .patch(`${path}/${id}`)
      .then((res) => {
        onSuccess(res.data.notification);
      })
      .catch(() => onError?.());
  }

  static markAllRead(
    userRole: UserRoleEnum | undefined,
    onSuccess: () => void,
    onError?: () => void
  ) {
    const path = basePath(userRole);
    if (!path) {
      onError?.();
      return;
    }
    axiosInstance
      .post(`${path}/mark_all_read`)
      .then(() => onSuccess())
      .catch(() => onError?.());
  }
}
